const baseConfig = require('./config.json');
const prefix = 'REACT_APP_';

// merge env variables from process.env into base config from Json
// only variables with specific prefix will be imported (and the prefix will be removed)
let config = Object.keys(process.env).reduce((prev, curr) => {
  if (curr.startsWith(prefix)) {
    return {
      ...prev,
      ...{ [curr.substr(prefix.length)]: process.env[curr] }
    };
  }
  return prev;
}, baseConfig);
// console.log('config=', config)

export default config;